import { BarChart3, Crosshair, Footprints, Trophy, Zap } from "lucide-react";

const Cell = ({ icon: I, label, value, testId }) => (
  <div className="flex min-w-0 flex-1 flex-col items-center text-center" data-testid={testId}>
    <I className="h-4 w-4 text-[#17A2A2]" />
    <p className="mt-0.5 truncate text-[9px] font-semibold leading-tight text-slate-500">{label}</p>
    <p className="whitespace-nowrap font-display text-sm font-extrabold leading-tight text-[#0A2540]">{value}</p>
  </div>
);

export const FeedbackPanel = ({ s, done, total, unit = "Pas" }) => (
  <div className="rounded-2xl border border-[#17A2A2]/30 bg-white/90 px-2 py-1.5 shadow-lg backdrop-blur-md" data-testid="feedback-panel">
    <p className="mb-1 text-[9px] font-extrabold uppercase tracking-[0.2em] text-[#0F7C7C]">Feedback en temps réel</p>
    <div className="flex divide-x divide-slate-200">
      <Cell icon={Crosshair} label="Précision" value={`${s.precision} %`} testId="fb-precision" />
      <Cell icon={Zap} label="Réaction" value={s.reaction ? `${s.reaction.toFixed(1).replace(".", ",")} s` : "—"} testId="fb-reaction" />
      <Cell icon={Footprints} label={unit} value={`${done} / ${total}`} testId="fb-steps" />
      <Cell icon={BarChart3} label="Amplitude" value={s.amplitude} testId="fb-amplitude" />
      <Cell icon={Trophy} label={s.steps ? "Tu progresses" : "Bravo !"} value={s.steps ? "Super !" : "À toi"} testId="fb-bravo" />
    </div>
  </div>
);
